import { render, staticRenderFns } from "./Video_management.vue?vue&type=template&id=3a7992ae"
import script from "./Video_management.vue?vue&type=script&lang=js"
export * from "./Video_management.vue?vue&type=script&lang=js"
import style0 from "./Video_management.vue?vue&type=style&index=0&id=3a7992ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports